import { skipToken } from "@reduxjs/toolkit/query";

import { useGetVersionsQuery } from "fond/api";
import { useFeatureFlag } from "fond/featureFlags";
import { useGetScenarioConfiguration } from "fond/hooks/useGetScenarioConfiguration";
import { Maybe, MultiProject, Project } from "fond/types";
import { isCollaborationProject, isMuPowerProject, isNBNCostToServeProject, isPlannerProject, isProject } from "fond/utils/project";

export const useCanViewBom = (project: Maybe<Project | MultiProject>): boolean => {
  const { hasConfig: isCollaborationCostToServe } = useGetScenarioConfiguration({
    projectId: isCollaborationProject(project) ? project.ID : undefined,
  });
  return isPlannerProject(project) || isCollaborationCostToServe || isMuPowerProject(project) || isNBNCostToServeProject(project);
};

export const useCanViewBomComparison = (project: Maybe<Project | MultiProject>): boolean => {
  const { value: isCompareBomsEnabled } = useFeatureFlag("compare_boms");
  const projectId = isProject(project) ? project.ID : undefined;
  const { hasConfig: isCollaborationCostToServe } = useGetScenarioConfiguration({
    projectId: isCollaborationProject(project) ? project.ID : undefined,
  });
  const { currentData: versions } = useGetVersionsQuery(projectId ?? skipToken);
  const hasMultipleVersions = (versions?.ids?.length ?? 0) > 1;

  return isCompareBomsEnabled && (isCollaborationCostToServe || isMuPowerProject(project)) && hasMultipleVersions;
};
